/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_RateInputs */



/**
* | output |
* | --- |
* | "Rate" |
*
* @param {Compare_Event_Groups_Option_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_rate = /** @type {((inputs?: Compare_Event_Groups_Option_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valutare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ставка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tasa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avaliar")
	return /** @type {LocalizedString} */ ("Rate")
});